module.exports = __webpack_public_path__ + "static/media/1012669.ab044996.jpg";